import React, { useState, useEffect, useContext } from "react";
import app from "../../FirebaseInit";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { AuthContext } from "../../Auth";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

function ViewRegisterForm() {
  let history = useHistory();
  const { currentUser } = useContext(AuthContext);
  const [data, setData] = useState(null);
  let query = useQuery();
  var id = query.get("id");

  useEffect(() => {
    var uid = currentUser.uid;
    if (id) uid = id;
    app
      .firestore()
      .collection("registerForms")
      .doc(uid)
      .get()
      .then((snap) => {
        if (!snap.exists) return history.push("/");
        if (snap.data().status != "approved") return history.push("/");
        setData(snap.data());
      });
  }, []);

  if (data == null)
    return (
      <center>
        <Loader type="ThreeDots" color="Black" width="50" height="50" />
      </center>
    );

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n        <!--\n        span.cls_003 {\n            font-family: "Calibri Bold", serif;\n            font-size: 18.5px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_003 {\n            font-family: "Calibri Bold", serif;\n            font-size: 18.5px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_004 {\n            font-family: "Calibri Bold", serif;\n            font-size: 15.6px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_004 {\n            font-family: "Calibri Bold", serif;\n            font-size: 15.6px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_007 {\n            font-family: "Calibri Bold", serif;\n            font-size: 10.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_007 {\n            font-family: "Calibri Bold", serif;\n            font-size: 10.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_005 {\n            font-family: "Calibri", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_005 {\n            font-family: "Calibri", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n        div.cls_0055 {\n            font-family: "Calibri", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n\n        span.cls_006 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_006 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_011 {\n            font-family: "Calibri", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: underline\n        }\n\n        div.cls_011 {\n            font-family: "Calibri", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_008 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_008 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_012 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: underline\n        }\n\n        div.cls_012 {\n            font-family: "Calibri Bold", serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_009 {\n            font-family: Arial, serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_009 {\n            font-family: Arial, serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_010 {\n            font-family: Arial, serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_010 {\n            font-family: Arial, serif;\n            font-size: 11.7px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n        .dotted {\n            border:0;\n            border-bottom: 2px dotted;\n            \n        }\n        .uploader {width:300px;height:350px;background:#f3f3f3;border:2px dashed #e8e8e8;}\n        \n        \n    ',
        }}
      />
      <div
        style={{
          position: "absolute",
          left: "50%",
          marginLeft: "-297px",
          top: "0px",
          width: "595px",
          height: "842px",
        }}
      >
        <div style={{ position: "absolute", left: "0px", top: "0px" }}>
          <img
            src={require("./9926f5d8-e798-11ea-8b25-0cc47a792c0a_id_9926f5d8-e798-11ea-8b25-0cc47a792c0a_files/background1.jpg")}
            width={595}
            height={842}
          />
        </div>
        <div
          style={{ position: "absolute", left: "54.84px", top: "110.80px" }}
          className="cls_003"
        >
          <span className="cls_003">
            Federation of Chambers of Commerce and Industry of Sri Lanka
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "267.06px", top: "136.72px" }}
          className="cls_003"
        >
          <span className="cls_003">(FCCISL)</span>
        </div>
        <div
          style={{ position: "absolute", left: "168.90px", top: "162.86px" }}
          className="cls_004"
        >
          <span className="cls_004">
            Certificate of Origin - Registration Form
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.14px", top: "203.28px" }}
          className="cls_007"
        >
          <span className="cls_007">REG NO: {data.RegId}</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "228.87px" }}
          className="cls_005"
        >
          <span className="cls_005">
            Name of the Company -{" "}
            <input
              type="text"
              id="CompanyName"
              className="dotted"
              size={50}
              disabled
              value={data.CompanyName}
            />{" "}
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "254.97px" }}
          className="cls_005"
        >
          <span className="cls_005">
            Company Registration No-{" "}
            <input
              type="text"
              id="CompanyRegistrationNo"
              className="dotted"
              size={50}
              disabled
              value={data.CompanyRegistrationNo}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "281.07px" }}
          className="cls_005"
        >
          <span className="cls_005">Postal Address -</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "307.23px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <input
              type="text"
              id="Address"
              className="dotted"
              size={83}
              disabled
              value={data.Address}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "333.27px" }}
          className="cls_005"
        >
          <span className="cls_005">
            Contact Person -
            <input
              type="text"
              id="ContactPerson"
              className="dotted"
              size={50}
              disabled
              value={data.ContactPerson}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "359.43px" }}
          className="cls_005"
        >
          <span className="cls_005">
            Designation -
            <input
              type="text"
              id="Designation"
              className="dotted"
              size={50}
              disabled
              value={data.Designation}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "385.53px" }}
          className="cls_005"
        >
          <span className="cls_005">Contact Details -</span>
        </div>
        <div
          style={{ position: "absolute", left: "140.04px", top: "385.53px" }}
          className="cls_005"
        >
          <span className="cls_005">Tel</span>
        </div>
        <div
          style={{ position: "absolute", left: "210.06px", top: "385.53px" }}
          className="cls_005"
        >
          <span className="cls_005">-</span>
        </div>
        <div
          style={{ position: "absolute", left: "247.68px", top: "385.53px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <input
              type="text"
              id="Telephone"
              className="dotted"
              size={30}
              disabled
              value={data.Telephone}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "140.04px", top: "411.57px" }}
          className="cls_005"
        >
          <span className="cls_005">Fax</span>
        </div>
        <div
          style={{ position: "absolute", left: "210.06px", top: "411.57px" }}
          className="cls_005"
        >
          <span className="cls_005">-</span>
        </div>
        <div
          style={{ position: "absolute", left: "247.68px", top: "411.57px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <input
              type="text"
              id="Fax"
              className="dotted"
              size={30}
              disabled
              value={data.Fax}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "140.04px", top: "437.73px" }}
          className="cls_005"
        >
          <span className="cls_005">E - Mail</span>
        </div>
        <div
          style={{ position: "absolute", left: "212.70px", top: "437.73px" }}
          className="cls_005"
        >
          <span className="cls_005">-</span>
        </div>
        <div
          style={{ position: "absolute", left: "247.68px", top: "437.73px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <input
              type="email"
              id="Email"
              className="dotted"
              size={30}
              disabled
              value={data.Email}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "463.83px" }}
          className="cls_005"
        >
          <span className="cls_005">
            Type of Product being exported -{" "}
            <input
              type="text"
              id="ProductType"
              className="dotted"
              size={40}
              disabled
              value={data.ProductType}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "489.93px" }}
          className="cls_006"
        >
          <span className="cls_006">
            Please register our company at FCCISL enabling us to obtain the
            Certificate of Origin.
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "505.29px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <img
              id="blah"
              src={data.companyseal}
              height="80"
              alt="your image"
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "594.33px" }}
          className="cls_005"
        >
          <span className="cls_005">Signature of Authorized Officer with </span>
          <span className="cls_011">Company Seal</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "620.49px" }}
          className="cls_005"
        >
          <span className="cls_005">Name</span>
        </div>
        <div
          style={{ position: "absolute", left: "105.06px", top: "620.49px" }}
          className="cls_005"
        >
          <span className="cls_005">:</span>
        </div>
        <div
          style={{ position: "absolute", left: "300.06px", top: "610.49px" }}
          className="cls_005"
        >
          <span className="cls_005">
            <img
              id="blah2"
              src={require("./../../asserts/seal.png")}
              width="200"
              alt="your image"
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "646.59px" }}
          className="cls_005"
        >
          <span className="cls_005">Designation</span>
        </div>
        <div
          style={{ position: "absolute", left: "105.06px", top: "646.59px" }}
          className="cls_005"
        >
          <span className="cls_005">:</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "672.69px" }}
          className="cls_005"
        >
          <span className="cls_005">Date</span>
        </div>
        <div
          style={{ position: "absolute", left: "105.06px", top: "672.69px" }}
          className="cls_005"
        >
          <span className="cls_005">:</span>
        </div>
        <div
          style={{ position: "absolute", left: "500.06px", top: "672.69px" }}
          className="cls_005"
        ></div>
        {/*----------------------------------------- Footer Area ----------------------------------*/}
        <div
          style={{ position: "absolute", left: "35.04px", top: "707.91px" }}
          className="cls_006"
        >
          <span className="cls_006">
            Federation of Chambers of Commerce and Industry
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "724.29px" }}
          className="cls_006"
        >
          <span className="cls_006">Federation House,</span>
          <span className="cls_008">
            {" "}
            # 696, 3/4, Havelock Road, Colombo 06, Sri Lanka.
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "740.61px" }}
          className="cls_006"
        >
          <span className="cls_006">Tel :+94 11 236 6996/7</span>
        </div>
        <div
          style={{ position: "absolute", left: "173.55px", top: "740.61px" }}
          className="cls_006"
        >
          <span className="cls_006">Fax :</span>
          <span className="cls_008"> +94 11 236 6992</span>
        </div>
        <div
          style={{ position: "absolute", left: "319.81px", top: "740.61px" }}
          className="cls_006"
        >
          <span className="cls_006">E-Mail : shyamalee@fccisl.lk</span>
        </div>
        <div
          style={{ position: "absolute", left: "482.93px", top: "740.61px" }}
          className="cls_006"
        >
          <span className="cls_006">Web: </span>
          <a href="http://www.fccisl.lk/">www.fccisl.lk</a>{" "}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          left: "50%",
          marginLeft: "-297px",
          top: "852px",
          width: "595px",
          height: "842px",
        }}
      >
        <div style={{ position: "absolute", left: "0px", top: "0px" }}>
          <img
            src={require("./9926f5d8-e798-11ea-8b25-0cc47a792c0a_id_9926f5d8-e798-11ea-8b25-0cc47a792c0a_files/background2.jpg")}
            width={595}
            height={842}
          />
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "56.97px" }}
          className="cls_012"
        >
          <span className="cls_012">ADDITIONAL INFORMATION</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "83.01px" }}
          className="cls_005"
        >
          <span className="cls_005">Payment Categories :</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "109.17px" }}
          className="cls_005"
        >
          <span className="cls_005">Chamber Member</span>
        </div>
        <div
          style={{ position: "absolute", left: "175.08px", top: "109.17px" }}
          className="cls_005"
        >
          <span className="cls_005">-</span>
        </div>
        <div
          style={{ position: "absolute", left: "210.06px", top: "109.17px" }}
          className="cls_005"
        >
          <span className="cls_005">LKR 1,000</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "135.27px" }}
          className="cls_005"
        >
          <span className="cls_005">Non - Chamber Member</span>
        </div>
        <div
          style={{ position: "absolute", left: "175.08px", top: "135.27px" }}
          className="cls_005"
        >
          <span className="cls_005">-</span>
        </div>
        <div
          style={{ position: "absolute", left: "210.06px", top: "135.27px" }}
          className="cls_005"
        >
          <span className="cls_005">LKR 2,000</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "161.37px" }}
          className="cls_012"
        >
          <span className="cls_012">
            NOTE : A COPY of the COMPANY REGISTRATION should be given along with
            the above registration form.
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "213.63px" }}
          className="cls_011"
        >
          <span className="cls_011">
            Essential Documents To Be Submitted When Obtaining A Certificate Of
            Origin
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "52.50px", top: "240.33px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_006"> A duly filled Certificate of Origin</span>
          <span className="cls_005">
            {" "}
            - A 100pg Certificate of Origin Book could be purchased from FCCISL
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "70.02px", top: "256.65px" }}
          className="cls_005"
        >
          <span className="cls_005">at the cost of Rs. 250/=</span>
        </div>
        <div
          style={{ position: "absolute", left: "52.50px", top: "273.69px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_006"> A duly filled “Form B” </span>
          <span className="cls_005">
            - An original Form B will be issued by FCCISL
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "52.50px", top: "290.73px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_006">
            {" "}
            A Customs Declaration Form (CUSDEC) or Commercial Invoice
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "342.93px" }}
          className="cls_011"
        >
          <span className="cls_011">NOTE :</span>
        </div>
        <div
          style={{ position: "absolute", left: "35.04px", top: "369.03px" }}
          className="cls_005"
        >
          <span className="cls_005">
            As per office policy and record keeping purposes FCCISL will require
            -
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "52.50px", top: "395.79px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_005">
            {" "}
            A copy of the duly filled Certificate of Origin
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "52.50px", top: "412.77px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_005"> A copy of the Form B</span>
        </div>
        <div
          style={{ position: "absolute", left: "52.49px", top: "429.81px" }}
          className="cls_009"
        >
          <span className="cls_009">•</span>
          <span className="cls_010"> </span>
          <span className="cls_005">
            {" "}
            A copy of the Customs Declaration Form (CUSDEC) or Commercial
            Invoice
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "52.49px", top: "455.91px" }}
          className="cls_005"
        >
          <span className="cls_005">
            From each Certificate of Origin issued.
          </span>
        </div>
      </div>
    </div>
  );
}

export default ViewRegisterForm;
